export default __webpack_public_path__ + "static/media/yellow_small.3261486a.png";